import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getStyleName, getDescriptionAndSuggestions } from '../utils/interpreter';
import './Result.css';

const Result = () => {
  const { type } = useParams();
  const navigate = useNavigate();
  const [results, setResults] = useState(null);
  const [styleInfo, setStyleInfo] = useState(null);
  const [description, setDescription] = useState('');
  const [suggestions, setSuggestions] = useState('');

  useEffect(() => {
    const resultsData = localStorage.getItem(`attachment_test_${type}_results`);

    if (resultsData) {
      const parsedResults = JSON.parse(resultsData);
      setResults(parsedResults);

      const style = getStyleName(parsedResults.attachmentStyle);
      setStyleInfo(style);

      const { description: desc, suggestions: sugg } = getDescriptionAndSuggestions(parsedResults.attachmentStyle);
      setDescription(desc);
      setSuggestions(sugg);
    } else {
      navigate('/');
    }
  }, [type, navigate]);

  const goToDetails = () => {
    navigate(`/details/${type}`);
  };

  const goToHome = () => {
    navigate('/');
  };

  if (!results || !styleInfo) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div className="result-container">
      <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">你的依恋风格</h1>
        </div>

        <div className="page-content">
          {/* 结果分享卡 */}
          <div className="share-card">
            <div className="share-card-header">
              <div className="share-card-icon">
                <span className="share-card-icon-inner">{styleInfo.name.charAt(0)}</span>
              </div>
              <h2 className="share-card-title">{styleInfo.name}</h2>
              <p className="share-card-subtitle">{styleInfo.nameEn}</p>
            </div>

            <div className="share-card-metrics">
              <div className="share-card-metric">
                <div className="metric-value">{results.anxiety.score}</div>
                <div className="metric-label">焦虑程度</div>
                <div className="metric-bar">
                  <div className="metric-bar-fill anxiety" style={{ width: `${(results.anxiety.score / 7) * 100}%` }}></div>
                </div>
              </div>
              <div className="share-card-metric">
                <div className="metric-value">{results.avoidance.score}</div>
                <div className="metric-label">回避程度</div>
                <div className="metric-bar">
                  <div className="metric-bar-fill avoidance" style={{ width: `${(results.avoidance.score / 7) * 100}%` }}></div>
                </div>
              </div>
            </div>
          </div>

          <div className="result-description">
            <div className="description-section">
              <h3 className="section-title">你的风格</h3>
              <p className="description-text">{description}</p>
            </div>

            <div className="suggestions-section">
              <h3 className="section-title">改善建议</h3>
              <p className="suggestions-text">{suggestions}</p>
            </div>
          </div>

          <div className="result-actions">
            <button className="btn btn-primary" onClick={goToDetails}>
              查看详细分析
            </button>
            <button className="btn btn-secondary" onClick={goToHome}>
              重新测试
            </button>
          </div>
        </div>

        <div className="footer-disclaimer">
          <p className="footer-disclaimer-text">
            本测试仅供参考，不能替代专业心理咨询<br />
            如有严重情绪问题，请及时寻求专业帮助
          </p>
          <p className="footer-copyright">
            © 2024 依恋型人格测试
          </p>
        </div>
      </div>
    </div>
  );
};

export default Result;
